import { useMutation } from '@tanstack/react-query'

import { uploadCorporateDocument } from '@src/api'
import { DefaultApiUploadCorporateDocumentRequest } from '@src/api/generated/user-api'
import { useAxios } from '@src/hooks/use-axios'

export const useUploadCorporateDocument = () => {
  const { axiosInstance } = useAxios()

  return useMutation({
    mutationFn: (params: DefaultApiUploadCorporateDocumentRequest) =>
      uploadCorporateDocument(axiosInstance, params),
  })
}
